import React from "react";
import {
  UploadDocComponent,
  DownloadExcelReport,
  UploadButton,
  ModalComponent,
  ModalTemplate
} from "../../reusableComponent";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  getDownloadAgendaAction,
  clearAgendaDownloadAction,
  uploadDownloadAgendaAction
} from "../../../actions/dowloadExcelActions";
import { toast } from "react-toastify";
import { FormDataForImage, isValidArray } from "../../../helper";
import DisplayByPermission from "../../../component/DisplayByPermission";
import { get } from "lodash";
import { successToastStyle, errorToastStyle } from "../../../customToast";
class DownloadUpload extends React.PureComponent {
  state = {
    toggleUploadPopUp: false,
    listofFiles: []
  };

  // on downloading
  onDownloading = () => {
    const { getDownloadAgendaAction, meetingId } = this.props;
    getDownloadAgendaAction(undefined, meetingId);
  };

  // on clear download button
  onClearDownload = () => {
    const { clearAgendaDownloadAction } = this.props;
    clearAgendaDownloadAction();
  };

  // toggle upload button
  onUploadToggle = () => {
    this.setState(prevState => ({
      toggleUploadPopUp: !prevState.toggleUploadPopUp
    }));
  };

  // upload files
  onUploadFile = e => {
    try {
      const { files } = e.target;
      const filesArr = [];
      // only on file can upload
      if (files.length > 1) {
        toast.error(
          <p className="toast-text-alignment">Only one file can be uploaded</p>,
          errorToastStyle
        );
        return false;
      }
      // extract the files
      for (let index = 0; index < files.length; index++) {
        const file = files[index];

        if (
          file.type !== "text/csv" &&
          file.type !== "application/vnd.ms-excel" &&
          file.type !==
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        ) {
          toast.error(
            <p className="toast-text-alignment">Only csv can be uploaded.</p>,
            errorToastStyle
          );
          return false;
        }
        filesArr.push(file);
      }
      this.setState({
        listofFiles: filesArr
      });
    } catch (error) {
      console.error(error);
    }
  };

  // on submit upload files
  onSubmitFile = async () => {
    try {
      const {
        uploadDownloadAgendaAction,
        meetingId,
        callApiOnSuccess
      } = this.props;
      const { listofFiles } = this.state;
      // if files is attached then upload will begin
      if (isValidArray(listofFiles)) {
        let formData = FormDataForImage(listofFiles, "multipartFile");
        const { data } = await uploadDownloadAgendaAction(
          undefined,
          meetingId,
          formData
        );
        this.setState({ toggleUploadPopUp: false, listofFiles: [] });
        data &&
          data.status &&
          typeof callApiOnSuccess === "function" &&
          callApiOnSuccess();
      } else {
        // if not file is attached
        toast.error(
          <p className="toast-text-alignment">
            No file is for uploading. Please attach a file.
          </p>,
          errorToastStyle
        );
      }
    } catch (error) {
      this.setState({ toggleUploadPopUp: false, listofFiles: [] });
      console.log(error);
    }
  };

  render() {
    const {
      state: { listofFiles, toggleUploadPopUp },
      props: { uploadAgendaReducer, downloadAgendaReducer, permission },
      onSubmitFile,
      onUploadFile,
      onDownloading,
      onUploadToggle,
      onClearDownload
    } = this;

    return (
      <>
        {toggleUploadPopUp ? (
          <ModalComponent
            centered
            isLoading={uploadAgendaReducer.isLoading}
            containerClass="download-upload-popup"
            onClose={onUploadToggle}
            template={
              <ModalTemplate
                onClose={onUploadToggle}
                onSubmit={onSubmitFile}
                onSubmitTitle="Upload"
                onCloseTitle="Close"
                headerTitle="Upload File"
                submitDisable={
                  !(isValidArray(listofFiles) && listofFiles.length)
                }
                bodyTemplate={
                  <>
                    <UploadDocComponent
                      filesName={listofFiles
                        .map(value => value.name)
                        .toString()}
                      feedback="* .csv file upto 5MB"
                      extensions=".csv"
                      onUpload={onUploadFile}
                    />
                    {isValidArray(listofFiles) ? (
                      <>
                        <h6 className="title">File</h6>
                        {listofFiles.map(value => (
                          <li key={value.name} className="uploded-image-names">
                            {value.name}
                          </li>
                        ))}
                      </>
                    ) : null}
                  </>
                }
              />
            }
          />
        ) : null}
        <span title="Download Decision form">
          <DownloadExcelReport
            isLoading={downloadAgendaReducer.isLoading}
            downloadLink={downloadAgendaReducer.downloadingSrc}
            onClearDownload={onClearDownload}
            onStartDownloading={onDownloading}
          />
        </span>
        <DisplayByPermission display={!get(permission, "canViewOnlyProject")}>
          <span title="Upload Decision form">
            <UploadButton onToggleUpload={onUploadToggle} />
          </span>
        </DisplayByPermission>
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    downloadAgendaReducer: state.donwloadExcelReducer.agendaDownload,
    uploadAgendaReducer: state.donwloadExcelReducer.agendaUpload
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getDownloadAgendaAction,
      clearAgendaDownloadAction,
      uploadDownloadAgendaAction
    },
    dispatch
  );
}

const DownloadUploadComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(DownloadUpload);
export { DownloadUploadComponent };
